import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect } from 'react';
import { APP_VERSION_NUMBER } from '@webtv/env';
import useLocalStorage, { transformers } from '@webtv/local-storage';
import { useTrack } from './track';

var useReportAppInstall = function useReportAppInstall() {
  var _useLocalStorage = useLocalStorage('HAS_REPORTED_APP_INSTALL', transformers.toBoolean),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      hasReportedInstall = _useLocalStorage2[0],
      setHasReported = _useLocalStorage2[1];

  var track = useTrack('Application Installed');
  useEffect(function () {
    if (!hasReportedInstall) {
      track({
        'App Build': APP_VERSION_NUMBER
      });
      setHasReported(true);
    }
  }, []);
};

export default useReportAppInstall;